import { AddItemButton, AddSupplierButton } from "../";
import axios from "axios";
import { apiURI, authErrorRedirect } from "../../../common";

export function setPageDetails(
  id,
  setAddButton,
  handleOpenAddItemSampleRequestModal,
  handleOpenAddSupplierSampleRequestModal,
  setPageDescription,
  setItemList,
  setDetailsData,
  setStatuses,
  setErrors,
  supplierButtonDisabled,
  history,
) {
  axios
    .get(`${apiURI}/form/id/${id}`)
    .then((response) => {
      let { procurementApproval, sampleRequestStatus, items, ...dataRest } =
        response.data;
      setItemList(items);
      setDetailsData(dataRest);
      setStatuses({
        procurementApproval,
        sampleRequestStatus,
      });
      switch (procurementApproval.status) {
        case "pending":
          setAddButton(AddItemButton(handleOpenAddItemSampleRequestModal));
          setPageDescription({
            title: "Approve or Reject Sample Request",
            subTitle:
              "Click on the items in the list to view in detail, edit, add, or delete them.",
          });
          break;
        case "Rejected":
          setPageDescription({
            title: "View Sample Request Details",
            subTitle: "Click on the items in the list to view in detail",
          });

          break;
        case "Accepted":
          setPageDescription({
            title: "Add Supplier Details",
            subTitle:
              "Add supplier details for the items given below in the list",
          });
          setAddButton([
            AddSupplierButton(
              handleOpenAddSupplierSampleRequestModal,
              supplierButtonDisabled,
            ),
            AddItemButton(handleOpenAddItemSampleRequestModal),
          ]);
          break;
        default:
          console.log("There was an error in All Requests Page Axios Call");
          setPageDescription({
            title: "View Sample Request Details",
            subTitle: "Click on the items in the list to view in detail",
          });
      }
    })
    .catch((error) => {
      console.log("error in axios page details react");
      setErrors({});
      setErrors(error.response?.data);
      authErrorRedirect(error.response?.data, history);
    });
}
